/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { updateDirectCampaignStateAsync } from '../../../../../../data-layer/direct/actions';
import { DirectCampaignUI } from '../../../../../../data-layer/direct/types';
import { useDispatch } from '../../../../../../data-layer/useDispatch';
import { useCurrentUser } from '../../../../../../routing/users/useCurrentUser';
import { getStatusButtonText } from '../utils/getStatusButtonText';

export const useCampaignActions = (company?: DirectCampaignUI) => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const status = getStatusButtonText(company);

    const processCampaign = useCallback(() => {
        if (!company || !status || !currentUser?.profile?.id) {
            return;
        }

        dispatch(updateDirectCampaignStateAsync(company.id, currentUser.profile.id, status));
    }, [company, currentUser, dispatch, status]);

    return {
        processCampaign,
    };
};
